import Blog from "./Blog";
import { useSelector } from "react-redux";
import { useState } from "react";
import Search from "./Search";

const BlogList = () => {
	const blogs = useSelector((state) => state);
	const [search, setSearch] = useState("");
	const [authorFilter, setAuthorFilter] = useState("");
	const [categoryFilter, setCategoryFilter] = useState("");

	const handleSearch = (key) => {
		setSearch(key);
	};

	const handleCategoryFilter = (key) => {
		setCategoryFilter(key);
	};

	const handleAuthorFilter = (key) => {
		setAuthorFilter(key);
	};

	const searchBlogs = (blog) => {
		if (search.length > 0) {
			return new RegExp(search, "i").test(blog.title);
		} else {
			return true;
		}
	};

	const filterByAuthor = (blog) => {
		if (authorFilter.length > 0) {
			return blog.author === authorFilter;
		} else {
			return true;
		}
	};

	const filterByCategory = (blog) => {
		if (categoryFilter.length > 0) {
			return blog.category === categoryFilter;
		} else {
			return true;
		}
	};

	return (
		<>
			<Search handleSearchKeyChange={handleSearch} search={search} />
			<section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
				<div className="absolute inset-0">
					<div className="bg-white h-1/3 sm:h-2/3"></div>
				</div>
				<div className="relative max-w-7xl mx-auto">
					<div className="text-center">
						<h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
							ALL BLOGS ARE HERE
						</h2>
						<p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
							libero labore natus atque, ducimus sed.
						</p>
					</div>

					<div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
						{blogs
							.filter(searchBlogs)
							.filter(filterByCategory)
							.filter(filterByAuthor)
							.map((blog) => (
								<Blog
									key={blog.id}
									blog={blog}
									handleCategoryFilter={handleCategoryFilter}
									handleAuthorFilter={handleAuthorFilter}
								/>
							))}
					</div>
				</div>
			</section>
		</>
	);
};

export default BlogList;
